import { createContext } from 'react';
import { UserProfileDto } from '../api/web-api-client';

export interface AccountDetails {
    organisation: string;
    trading: string;
    branch: string;
    homeAccountId: string;
    givenName?: string;
    familyName?: string;
    email?: string;
    abn?: string;
    targetOrganisation?: TargetOrganisation;
    userAcceptedTermsOfUse: boolean;
    accountCreationCompleted: boolean;
    accountContactCompleted: boolean;
    currentTermsVersion: string;
    defaultOrganisationId?: number;
    organisationCRMGuid?: string;
    organisationIsCompleted: boolean;
    isDefaultOrganisation: boolean;
    showBranchSelector: boolean;
    branchSelectionModalMode?: string;
    callingPath?: string;
    rfqId?: string;
    contactId?: number;
    userProfile?: UserProfileDto;
}

export interface AccountContextState {
    isLoading?: boolean;
    details: AccountDetails | null;
    setAgree: () => void;
    setCompleted: () => void;
    setContactCompleted: () => void;
    setDefaultOrganisationId: (defaultOrganisationId: number | undefined, defaultOrganisationCRMId: string | undefined) => void;
    setTargetOrganisation: (targetOrganisationAbn: string, targetOrganisationName: string) => void;
    setOrganisationAndBranch: (organisationName: string, tradingName: string, branchName: string) => void;
    setShowBranchSelector: (show: boolean) => void;
    setShowRFQSelectModal: (show: boolean, rfqId: string, callingPath: string) => void;
    setUserProfile: (userProfile: UserProfileDto) => Promise<boolean>;
}

export interface TargetOrganisation {
    targetOrganisationAbn: string;
    targetOrganisationName: string;
}

const AccountContext = createContext<AccountContextState | null>(null);

export default AccountContext;
